import moment from "moment";
import { getAuthToken } from "./API/authStorage";
import { CheckOutlined, CloseOutlined, CopyOutlined } from '@ant-design/icons';
import { Tooltip, notification } from "antd";

export const apiGenerator = (apiObject, exchangePair = {}, join = null) => {
  const apiObj = { ...apiObject };
  if (Object.keys(exchangePair).length) {
    Object.keys(exchangePair).forEach((el) => {
      apiObj.endpoint = apiObj.endpoint.replace(`:${el}`, exchangePair[el]);
    });
  }

  if (join) {
    apiObj.endpoint = `${apiObj.endpoint}${join}`;
  }
  return apiObj;
};


export const isLogin = () => {
  return getAuthToken() !== undefined && getAuthToken() !== null;
};

export const FOND_MODES = {
  0: "SOS Mode",
  1: "Normal or Default Mode",
  2: "Walk Mode",
  3: "Boarding Mode",
  4: "Super Saver Mode",
}

export const ROLES = {
  'ClientSupport': 'ClientSupport',
  'Manufacturer': 'Manufacturer',
  'Admin': 'Admin',
}
export const convertUTCToLocal = (utcTime, format = 'YYYY-MM-DD HH:mm:ss') => {
  const localTime = moment.utc(utcTime).local().format(format);
  return localTime;
};


export const generateMenuFromRoutes = (routes = [], role, basePath = "") => {
  let menu = [];


  routes?.forEach((route) => {
    let nestedBasePath = route?.index
      ? basePath
      : route?.path
        ? route.path
        : "/";
    nestedBasePath = nestedBasePath.trim().replace("//", "/");
    const menuItem = {
      id: nestedBasePath,
      icon: route?.icon,
      label: route?.label,
      key: nestedBasePath,
    };

    if (route?.children && route?.children?.length > 0) {
      // Recursive call for nested children

      const children = generateMenuFromRoutes(
        route?.children,
        role,
        nestedBasePath
      );
      if (children.length) menuItem.children = children;
    }
    if (route?.icon && (!route?.Role || route?.Role?.includes(role))) {
      menu?.push(menuItem);
    } else if (
      menuItem?.children?.length &&
      (!route?.Role || route?.Role?.includes(role))
    ) {
      menu?.push(...menuItem.children);
    }
  });
  return menu;
};

export const generateRoutes = (routes = [], role) => {
  let Routes = [];
  routes?.forEach((route) => {
    const mainRoute = { ...route };
    if (route?.children && route?.children?.length > 0) {
      // Recursive call for nested children

      const children = generateRoutes(route?.children, role);
      if (children.length) mainRoute.children = children;
    }
    if (!route?.Role || route?.Role?.includes(role)) {
      Routes?.push(mainRoute);
    } else if (
      mainRoute?.children?.length &&
      (!route?.Role || route?.Role?.includes(role))
    ) {
      Routes?.push(...mainRoute.children);
    }
  });
  return Routes;
};

export const DEVICE = {
  1: "FlufFit 1",
  2: "FlufFit 2",
}

export const DEVICE_CONNECTION = {
  true: <CheckOutlined className="!text-[#0345A2] !text-xl" />,
  false: <CloseOutlined className="!text-[#F44400] !text-xl" />,
}


export const ACTIVE_STATUS = {
  true: 'Yes',
  false: 'No'
}

export const DEVICE_STATUS = {
  true: <p className="text-[#179415]">Active</p>,
  false: <p className="text-[#F44400]">In-Active</p>,
}

export const copyHandler = (id, type) => {
  try {
    window.navigator.clipboard.writeText(id)
    notification.success({ message: `${type} Id Copied` })

  } catch (error) {
    notification.error({ message: 'Something went wrong' })
  }
}

export const COPY_UNIQUE_ID = (id, type = 'Unique') => {
  return <div> {id} <Tooltip title={`Copy ${type} Id`}> <CopyOutlined onClick={() => {
    copyHandler(id, type)
  }} /></Tooltip> </div>
}

export const compareTime = (date1, date2) => {
  const time1 = moment(date1?.time);
  const time2 = moment(date2?.time);

  if (time1.isAfter(time2)) {
    return date1
  } else {
    return date2
  }

}